import { render } from "./FixedFooter.vue?vue&type=template&id=120827e3&scoped=true"
import script from "./FixedFooter.vue?vue&type=script&lang=js"
export * from "./FixedFooter.vue?vue&type=script&lang=js"

import "./FixedFooter.vue?vue&type=style&index=0&id=120827e3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120827e3"]])

export default __exports__